<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>答题管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-row class="title_row">
        <el-col>
          <span class="title_class">信息筛选</span>
        </el-col>
      </el-row>
      <el-form
        :model="queryForm"
        class="filter_Form"
        label-width="70px"
        ref="queryFormRef"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="赛季" prop="season">
              <el-select
                placeholder="请选择赛季"
                style="width: 100%"
                v-model="queryForm.season"
              >
                <el-option
                  v-for="item in dict_season"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="赛区" prop="districtId">
              <el-select
                placeholder="请选择赛区"
                style="width: 100%"
                clearable
                v-model="queryForm.districtId"
              >
                <el-option
                  v-for="item in dict_district"
                  :key="item.id"
                  :label="item.districtName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
          </el-col>
          <el-col :span="6">
            <el-form-item label="参赛码" prop="matchCode">
              <el-input
                v-model="queryForm.matchCode"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="queryForm.name"
                placeholder="请输入姓名"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号" prop="phone">
              <el-input
                v-model="queryForm.phone"
                placeholder="请输入"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="组别" prop="level">
              <el-select
                v-model="queryForm.level"
                placeholder="请选择组别"
                style="width: 100%"
                @change="search"
                >
                <el-option
                  v-for="item in dict_group"
                  :key="item.dictValue"
                  :label="item.dictLabel"
                  :value="item.dictValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" align="right">
            <el-button
              type="primary"
              @click="search">查询</el-button>
            <el-button type="primary" @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <!-- 列表 -->
    <el-card style="margin-top: 15px">
      <el-row class="title_row" align="middle" type="flex">
        <el-col :span="6">
          <span class="title_class">选手列表</span>
        </el-col>
        <el-col :span="18" style="text-align: right;">
          <el-button type="primary" size="small" @click="addedScoreCalc">1.计算附加分</el-button>
          <el-button type="primary" size="small"  @click="showRevive">2.设置晋级</el-button>
          <el-button type="primary" size="small" plain @click="exportFn" icon="el-icon-download">导出成绩</el-button>
          <el-button type="primary" size="small" plain @click="copyScreenLink" icon="el-icon-link">复制大屏链接</el-button>
        </el-col>
      </el-row>
      <el-table
        header-cell-class-name="tableHeaderStyle"
        :data="dataList"
        border
        stripe
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛区" prop="district"></el-table-column>
        <el-table-column label="参赛码" prop="matchCode" v-if="queryForm.raceSchedule === 2"></el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="手机号" prop="phone" width="100px"></el-table-column>
        <el-table-column label="性别" prop="sex">
          <template slot-scope="scope">
            {{ scope.row.sex == 1 ? '男' : scope.row.sex == 0 ? '女' : '未设置' }}
          </template>
        </el-table-column>
        <el-table-column label="签到时间" prop="signTime" width="100"></el-table-column>
        <el-table-column label="分数" prop="score"></el-table-column>
        <el-table-column label="答题时长" prop="times" :formatter="formatSeconds" width="100"></el-table-column>
        <el-table-column label="附加分" prop="addesScore"></el-table-column>
        <el-table-column label="答题状态" prop="result">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.result ? 'success' : 'danger'">{{ scope.row.result ? '已完成' : '未完成' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="晋级状态" prop="promotion">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.promotion === 2 ? 'danger' : scope.row.promotion === 1 ? 'success' : 'info'">
              {{ scope.row.promotion === 2 ? '未晋级' : scope.row.promotion === 1 ? '已晋级' : '未设置'  }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="交卷时间" prop="submitTime" width="100"></el-table-column>
        <el-table-column label="学校" prop="school" width="180"></el-table-column>
        <el-table-column label="年级" prop="grade" :formatter="gradeFormatter"></el-table-column>
        <el-table-column label="操作" width="140px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showPromotion(scope.row)">设置晋级</el-button>
            <el-button type="text" size="small" @click="showDetail(scope.row)">答题详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageIndex"
        :page-sizes="[10, 20, 40, 80]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <el-dialog title="设置晋级" width="480px"
      :visible.sync="promotionVisible">
      <div style="margin-bottom: 20px;">
        <span style="margin-right: 10px;width: 80px;display: inline-block;">晋级状态</span>
        <el-radio-group v-model="promotion">
          <el-radio :label="0">未设置</el-radio>
          <el-radio :label="1">晋级</el-radio>
          <el-radio :label="2">未晋级</el-radio>
        </el-radio-group>
      </div>
      <div>
        <span style="margin-right: 10px;width: 80px;display: inline-block;">备注</span>
        <el-input v-model="note" style="width: 240px;"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setPromotion">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 答题详情 -->
    <el-dialog
      title="作答详情"
      :visible.sync="dialogVisible"
      width="1100px">
      <el-row>
        <el-col :span="8"><div class="total">姓名：<span>{{ userName }}</span></div></el-col>
        <el-col :span="8"><div class="total">电话：<span>{{ phone }}</span></div></el-col>
        <el-col :span="8"><div class="total">成绩：<span>{{ totalScore }}</span></div></el-col>
      </el-row>
      <template>
        <div class="default" v-if="!resultList.length">
          暂无作答记录
        </div>
        <div class="question-item" v-for="(item, index) in resultList" :key="index">
          <div class="a-title">
            <el-tag type="primary" size="small" class="tag">Part {{ index+1 }}</el-tag>
            <el-tag type="success" size="small" class="tag">{{ item.questionType }}</el-tag>
            <span class="text">{{ item.description }}</span>
          </div>
          <div class="question-title" v-if="item.title">{{ item.title }}</div>
          <img class="img-desc" v-if="item.imageDdescription" :src="item.imageDdescription" alt="">
          <div class="questionDdescription" v-if="item.questionDdescription" v-html="item.questionDdescription"></div>
          <el-table header-cell-class-name="tableHeaderStyle" :data="item.type !== 'choiceSpell' ? item.questions : item.question.answers" stripe border>
            <el-table-column label="题号" :width="item.type !== 'choiceSpell' ? '150px' : ''">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.example" effect="dark" type="primary">例题</el-tag>
                <div v-else-if="scope.row.sort">{{ scope.row.sort }}</div>
              </template>
            </el-table-column>
            <el-table-column label="题目" prop="selval" v-if="item.type !== 'choiceSpell'">
              <template slot-scope="scope">
                <div v-if="item.type === 'singleChoice'">
                  <div class="question mb-6" v-if="scope.row.questionType === 'text'">{{ scope.row.question }}</div>
                  <img class="question-img" v-else-if="scope.row.questionType === 'image'" :src="scope.row.question" alt="">
                  <div class="flex">
                    <div class="opt" v-for="(opt, j) in scope.row.options" :key="j">
                      <div class="opt-index">{{ opt.option }}.</div>
                      <div>
                        <img class="opt-img" v-if="scope.row.optionType === 'image'" :src="opt.definition" alt="">
                        <div v-else>
                          {{ opt.definition }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="question" v-else-if="item.type === 'judge'">
                  {{ scope.row.question }}
                </div>
                <div v-else-if="item.type === 'line'">
                  <img class="opt-img" :src="scope.row.imageUrl">
                </div>
              </template>
            </el-table-column>
            <el-table-column label="正确答案" prop="answer" :width="item.type !== 'choiceSpell' ? '90px' : ''" align="center">
              <template slot-scope="scope">
                <div v-if="item.type === 'judge'">
                  <el-tag type="success" size="small" effect="dark" v-if="scope.row.answer === 'true'">Yes</el-tag>
                  <el-tag type="warning" size="small" effect="dark" v-else>No</el-tag>
                </div>
                <div v-else>{{ scope.row.answer }}</div>
              </template>
            </el-table-column>
            <el-table-column label="用户答案" prop="userAnswer" :width="item.type !== 'choiceSpell' ? '90px' : ''" align="center">
              <template slot-scope="scope">
                <div v-if="item.type === 'judge'">
                  <el-tag type="success" size="small" effect="dark" v-if="scope.row.userAnswer === 'true'">Yes</el-tag>
                  <el-tag type="warning" size="small" effect="dark" v-else>No</el-tag>
                </div>
                <div v-else>{{ scope.row.userAnswer }}</div>
              </template>
            </el-table-column>
            <el-table-column label="得分" prop="getScore" :width="item.type !== 'choiceSpell' ? '90px' : ''" align="center"></el-table-column>
            <el-table-column label="判定" prop="isRight" :width="item.type !== 'choiceSpell' ? '90px' : ''" align="center">
              <template slot-scope="scope" >
                <el-tag v-if="scope.row.isRight !== undefined" :type="scope.row.isRight ? 'success' : 'danger'" size="mini">{{scope.row.isRight ? '正确' : '错误'}}</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </el-dialog>
    <el-dialog
      title="计算附加分"
      :visible.sync="addedScoreVisible">
      <el-form label-width="70px">
        <el-form-item label="组别" prop="level">
          <el-select
            v-model="level"
            placeholder="请选择组别"
            style="width: 100%"
            >
            <el-option
              v-for="item in dict_group"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addedScoreCalc">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 批量设置晋级 -->
    <el-dialog
      title="设置晋级"
      width="900px"
      :visible.sync="reviveVisible">
      <div class="tip">请确认所有选手已提交，再进行设置。</div>
      <el-form>
        <el-row>
          <el-col class="t" :span="8">组别</el-col>
          <el-col class="t" :span="8">晋级类型</el-col>
          <el-col class="t" :span="8">晋级人数/比例</el-col>
        </el-row>
        <el-row v-for="(item, i) in levelList" :key="i">
          <el-col :span="8">
            <el-form-item prop="level">
              {{ item.levelName }}（{{ item.count }}人）
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="level">
              <el-radio-group v-model="item.radio" @input="radioChange(item, i)">
                <el-radio :label="1">人数</el-radio>
                <el-radio :label="2">比例</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="item.radio === 1">
            <el-form-item prop="num">
              <el-input v-model="item.num" style="width: 140px;"></el-input> 人
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="item.radio === 2">
            <el-form-item prop="rate">
              <el-input v-model="item.rate" style="width: 140px;"></el-input> %
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setReviveFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { queryDistrictPage } from '@/http/api'

export default {
  data () {
    return {
      setPassDialogVisible: false,
      dict_district: [],
      dict_season: [],
      dict_matchType: [],
      dict_grade: this.$userInfo.getGradeData(),
      dict_group: this.$userInfo.dict_group(),
      queryForm: {
        season: this.$chnEngStatusCode.defaultSeason,
        districtId: '',
        matchCode: '',
        phone: '',
        name: '',
        level: '',
        matchState: ''
      },
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      dateRange: [],
      dialogVisible: false,
      questionListData: [],
      totalScore: 0,
      userName: '',
      phone: '',
      infoVisible: false,
      editForm: {},
      editFormRules: {
        grade: [{ required: true, message: '请选择', trigger: 'change' }],
        sex: [{ required: true, message: '请选择', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入', trigger: 'blur' }],
        school: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      matchVisible: false,
      tagType: '',
      tagStr: '',
      resultList: [],
      addedScoreVisible: false,
      level: '',
      reviveVisible: false,
      rate: '80',
      num: '',
      radio: 1,
      noSignInList: [],
      promotionVisible: false,
      promotion: '',
      note: '',
      notSignNum: 0,
      signNum: 0,
      totalNum: 0,
      levelList: []
    }
  },
  created () {
    const code = this.$route.query.code
    this.queryForm.matchCode = code

    this.getSeason()
    this.getDistrictList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    seasonStr (season) {
      return this.dict_season.find(item => item.dictValue === season) ? this.dict_season.find(item => item.dictValue === season).dictLabel + '赛季' : ''
    },
    formatSeconds (data) {
      if (data.times) {
        const minutes = Math.floor(data.times / 60)
        const remainingSeconds = data.times % 60
        return `${minutes}分${remainingSeconds}秒`
      } else {
        return ''
      }
    },
    getSeason () {
      this.$userInfo.getDataList(this, 't_season', this.$store.state.flag).then(value => {
        this.dict_season = value
        this.getDataList()
      })
    },
    // 获取赛区筛选数据
    getDistrictList () {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list
      }).catch((err) => {
        console.log('err', err)
      })
    },
    getDataList () {
      this.$http.get('gcsccMatchCode/resultPage', { params: { ...this.queryForm, ...{ pageNum: this.pageIndex, pageSize: this.pageSize } } }).then(res => {
        this.dataList = res.data.list
        this.total = res.data.total
      })
    },
    search () {
      this.pageIndex = 1
      this.getDataList()
    },
    reset () {
      this.$refs.queryFormRef.resetFields()
      if (this.queryForm.startMatchTime) {
        delete this.queryForm.startMatchTime
        delete this.queryForm.endMatchTime
        this.dateRange = []
      }
      this.search()
    },
    handleSizeChange (e) {
      this.pageSize = e
      this.getDataList()
    },
    handleCurrentChange (e) {
      this.pageIndex = e
      this.getDataList()
    },
    exportFn () {
      this.$message('导出中...')
      const downLoadUrl = `${this.$http.defaults.baseURL}gcsccMatchCode/exportResult`
      this.$downLoadFile.downLoadFileWithUrl(this, downLoadUrl, '', { ...this.queryForm, ...{ pageNum: this.pageIndex, pageSize: this.pageSize } })
    },
    gradeFormatter (data) {
      var temp = '未设置'
      for (const key in this.dict_grade) {
        if (Object.hasOwnProperty.call(this.dict_grade, key)) {
          const element = this.dict_grade[key]
          if (element.dictValue === data.grade) {
            temp = element.dictLabel
          }
        }
      }
      return temp
    },
    dateChange (e) {
      this.queryForm.startMatchTime = this.$moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      this.queryForm.endMatchTime = this.$moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    },

    showDetail (data) {
      if (!data.result) return this.$message.warning('暂无答题记录')
      this.dialogVisible = true
      const result = JSON.parse(data.result)
      this.resultList = result
      this.totalScore = data.score
      this.userName = data.name
      this.phone = data.phone
    },
    showAddedScore () {
      // 全国总决选小组常规赛，得分相同的，答题时间越少分数越高，需要计算。
      this.level = ''
      this.addedScoreVisible = true
    },
    addedScoreCalc () {
      this.$http.post('gcsccMatchCode/addedScore', {
        season: this.queryForm.season,
        matchCode: this.queryForm.matchCode
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('计算完成')
          this.search()
        }
      })
    },
    showRevive () {
      this.$http.get('gcsccMatchCode/getUserNumByLevel', { params: { code: this.queryForm.matchCode } }).then(res => {
        if (res.code === 200) {
          this.reviveVisible = true
          this.levelList = res.data.map(item => {
            return { ...item, ...{ num: '', rate: '', radio: 1 } }
          })
        }
      })
      // this.levelList = [
      //   { level: 0, num: '', rate: '', radio: 1 },
      //   { level: 1, num: '', rate: '', radio: 1 },
      //   { level: 2, num: '', rate: '', radio: 1 },
      //   { level: 3, num: '', rate: '', radio: 1 },
      //   { level: 4, num: '', rate: '', radio: 1 }
      // ]
    },
    setReviveFn () {
      const form = {
        season: this.queryForm.season,
        matchCode: this.queryForm.matchCode,
        dataList: this.levelList
      }
      this.$http.post('gcsccMatchCode/setRevive', form).then(res => {
        if (res.code === 200) {
          this.$message.success('设置成功')
          this.reviveVisible = false
          this.getDataList()
        }
      })
    },
    showInfo (data) {
      this.editForm = data
      console.log(this.editForm)
      this.infoVisible = true
    },
    // 批量设置晋级弹窗关闭
    setPassDialogClose () {
      this.setPassSchoolList = []
      this.$refs.setPassFormRef.resetFields()
    },
    // code
    copyScreenLink () {
      var input = document.createElement('input') // 创建input标签
      var location = window.location.origin
      input.value = `${location}/#/gcsccRank?code=${this.queryForm.matchCode}`
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    },
    handleToChangeStatus (status) {
      this.$http.post('formMatchCode/updateStatus', { code: this.queryForm.matchCode, status }).then(res => {
        if (res.code === 200) {
          this.$message.success('操作成功')
        }
      })
    },
    radioChange (item, i) {
      this.levelList[i].num = ''
      this.levelList[i].rate = ''
    },
    showPromotion (item) {
      this.promotion = item.promotion
      this.id = item.id
      this.promotionVisible = true
    },
    setPromotion () {
      this.$http.post('gcsccMatchCode/updatPromotion', {
        id: this.id,
        promotion: this.promotion,
        note: this.note
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('设置成功')
          this.promotionVisible = false
          this.getDataList()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .h1{
    color: #000;
    margin-top: 20px;
  }
  .h2{
    color: #000;
  }
  .total{
    font-size: 16px;
    color: #000;
    span{
      color: #409EFF;
    }
  }
  .font{
    margin-right: 12px;
  }

  .answer-img{
    width: 40px;
  }
  .selval{
    font-weight: bold;
  }
  .el-radio__original {
    display: none !important; /* 隐藏原生 radio 输入，但仍然允许交互 */
  }
  .question-item{
    .question-title{
      font-size: 14px;
      font-weight: bold;
      color: #000;
      width: 400px;
      text-align: center;
      margin: 0 auto 10px;
    }
    .a-title{
      color: #000;
      font-weight: bold;
      margin-bottom: 20px;
      margin-top: 20px;
      .tag{
        margin-right: 10px;
      }
      .text{
        font-size: 14px;
      }
    }
    .question{
      color: #000;
      font-size: 14px;
    }
    .question-img{
      width: 260px;
    }
    .mb-6{
      margin-bottom: 6px;
    }
    .img-desc{
      display: block;
      width: 400px;
      margin: 0 auto 20px;
    }
    .flex{
      display: flex;
      justify-content: space-between;
    }
    .opt{
      display: flex;
      flex: 1;
    }
    .opt-index{
      margin-right: 4px;
    }
    .opt-img{
      width: 80px;
    }
    .questionDdescription{
      border: 1px dashed #409EFF;
      border-radius: 10px;
      padding: 20px;
      color: #000;
      line-height: 36px;
    }
  }
  .default{
    text-align: center;
    padding: 50px;
    color: #999;
    font-size: 14px;
  }
  .title{
    color: #000;
    font-size: 20px;
    text-align: center;
  }
  .title-flex{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    margin-top: 10px;
    div{
      margin-left: 30px;
    }
    span{
      color: #409EFF;
      font-weight: bold;
      font-size: 20px;
    }
  }
  .tip{
    margin-bottom: 20px;
    font-size: 14px;
    color: red;
  }
  .title-flex1{
    // justify-content: flex-start;
    font-size: 16px;
  }
  .t{
    padding: 10px;
    background-color: #ECF5FF;
    color: #409EFF;
    margin-bottom: 22px;
  }
</style>
